import React from "react";
import { withNativeProps } from "../../utils/with-native-props";
import { mergeProps } from "../../utils/mergeProps";
import { attachPropertiesToComponent } from "../../utils/attach-properties-to-component";
import { toCSSLength } from "../../utils/to-css-length";
var classPrefix = "tc-grid";
export var Grid = function Grid(props) {
  var _a;
  var style = {
    "--columns": (_a = props.columns) === null || _a === void 0 ? void 0 : _a.toString()
  };
  var gap = props.gap;
  if (gap !== undefined) {
    if (Array.isArray(gap)) {
      style["--gap-horizontal"] = toCSSLength(gap[0]);
      style["--gap-vertical"] = toCSSLength(gap[1]);
    } else {
      style["--gap"] = toCSSLength(gap);
    }
  }
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix,
    style: style
  }, props.children));
};
export var GridItem = function GridItem(p) {
  var props = mergeProps({
    span: 1
  }, p);
  var itemStyle = {
    "--item-span": props.span
  };
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-item"),
    style: itemStyle,
    onClick: props.onClick
  }, props.children));
};
Grid.defaultProps = {};
export default attachPropertiesToComponent(Grid, {
  Item: GridItem
});